(function (Drupal, $, once) {
  Drupal.behaviors.banner = {
    attach: function (context) {
      $(function () {
        if (
          $("main.main-content__wrapper.sidebar-second").length &&
          $(".paragraph-banner__wrapper").length
        ) {
          $(".main-content__wrapper .paragraph-banner__wrapper").insertBefore(
            "main.main-content__wrapper"
          );
          $(".paragraph-banner__wrapper").show();
        }
        $(once('intro-quick-links-title', '.paragraph-intro-quick-links__items-tab--title')).on("click", function () {
            if (!window.matchMedia("(min-width: 1024px)").matches) {
              $(this).toggleClass("open");
              $(this)
                .siblings(".paragraph-intro-quick-links__items-tab--links")
                .stop()
                .slideToggle("fast");
            }
          });
      });
    },
  };
})(Drupal, jQuery, once);
